module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-num"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerhauptquartiere Wolfsschanze")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The German invasion of the Soviet Union on 22 June 1941 shocked the world; it was though, hardly a surprise. Hitler had made his intentions quite clear many years earlier. After his failed coup in 1923, he had been incarcerated in Landsberg Prison, where he began work on his quasi-autobiographical book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mein Kampf")]), _vm._v(", in which he set out his political ideology and his future hopes for Germany. In this he wrote, with reference to the First World War: ‘If new territory were to be acquired in Europe it must have been mainly at Russia’s cost, and once again the new German Empire should have set out on its march along the same road as was formerly trodden by the Teutonic Knights, this time to acquire soil for the German plough by means of the German sword and thus provide the nation with its daily bread.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hitler was fixated with the acquisition of more territory for the expanding German nation – the infamous "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lebensraum")]), _vm._v(", or living space – and he made it quite clear where that living space would be found: ‘We shall soon reach a point beyond which the resources of our soil can no longer be exploited,’ he wrote, ‘and at the same time we shall reach a point beyond which our man-power cannot develop . . . If we speak of soil in Europe today, we can primarily have in mind only Russia and her vassal border states.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remarkably, he was able to find a justification for seizing Russian territory: ‘One must calmly and squarely face the truth that it certainly cannot be part of the dispensation of Divine Providence to give a fifty times larger share of the soil of this world to one nation than to another. In considering this state of affairs to-day, one must not allow existing political frontiers to distract attention from what ought to exist on principles of strict justice. If this earth has sufficient room for all, then we ought to have that share of the soil which is absolutely necessary for our existence.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having stated his beliefs in this fashion and repeated such philosophies many times during the intervening years, Hitler felt impelled to fulfil these promises to his people. He would give them their "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lebensraum")]), _vm._v(" and would clear the Slavs from the territory he won – and it would be won by the sword. Few then, could have doubted that at some point, Germany would invade the Soviet Union.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, one day in 1941, while sitting in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerbunker")]), _vm._v(" in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" alone with his friend and photographer, Heinrich Hoffmann, Hitler gave quite a different explanation for the attack upon the Soviet Union: "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("‘Through a concatenation of circumstances, I was compelled to take the first step in what is a war of prevention – and let me emphasise, it must be explained with the utmost clarity to the German people, that is indeed a war of prevention. It was vital that I get my blow in first, before the Russians struck . . . We need oil for our aircraft, oil for our armour, and the thrust towards the Russian oilfields must at all costs succeed.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn1",
      "id": "ch1fn1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hitler’s first step eastward was taken on 1 September 1939, when he invaded Poland. Stalin and his acolytes had been duped into a pact with Germany that enabled the Führer to attack Poland knowing that the Soviets would join him in occupying and partitioning the country. When the subjugation of Poland had been accomplished, German and Soviet forces faced each other across the agreed demarcation line. While Stalin believed that Hitler had achieved his ends and that he would honour the terms of the Molotov–Ribbentrop Pact, Hitler was planning the invasion of Russia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the autumn of 1940, Dr Fritz Todt, a construction engineer who had formed a civil and military engineering organisation, Organisation Todt (OT), and who in March of that year had been made Reich Minister for Armaments and Ammunition, was instructed to find a suitable site for the establishment of a headquarters complex close to the border with the Soviets from where the Führer and his staff could direct the assault upon the USSR.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Todt set off for East Prussia, taking with him his army adjutant, Hauptmann (later Generalleutnant) Gerhard Engel, and other headquarters staff and construction specialists. After a prolonged search, a site was found deep inside the forest of Görlitz, 5 miles to the east of the town of Rastenburg, which is today’s Polish town of Kętrzyn, and 50 miles from the Soviet border. There would be built the largest of all the Führer headquarters ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerhauptquartiere")]), _vm._v("), which during its secret construction was called the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chemische Werke Askania")]), _vm._v(" (Askania Chemical Works) or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Nord")]), _vm._v(" (Camp, or installation or facility, North) but would soon be known as the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" – the Wolf’s Lair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were a number of reasons why the Görlitz forest was chosen by Todt. To the east is the great Mazurian Lakes system, which forms a 70km-long natural water obstacle against ground-based troops. Also to the east, between two of the larger lakes, is the Boyen fortress (more of which in a later chapter) which was situated in an important strategic position and had played a part in the momentous Battle of Tannenberg against the Russians in the First World War. There were also barracks and garrison towns in the general vicinity. One-third of the area was woodland and it was only sparsely populated, both of which helped with security and concealment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The need for a static base close to the centre of operations had become clear during the invasion of Poland in 1939. Before the outbreak of hostilities, no measures had been taken to establish a forward command post for the war for either Hitler or the High Command of the Armed Forces, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oberkommando")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("der Wehrmacht")]), _vm._v(" (OKW). This meant that the leadership travelled around on Hitler’s special command train, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führersonderzug Amerika")]), _vm._v(", while the senior staff of the army, the Heer, and the air force, the Luftwaffe, were sitting in their own respective headquarters. Clearly, this was an unsatisfactory arrangement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though Hitler had been persuaded to establish a settled base for the invasion of France and the Low Countries in May 1940, the first of the static "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerhauptquartiere")]), _vm._v(", the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Felsennest")]), _vm._v(" (Rocky Nest), was small and cramped, with just four rooms. It would be quite different for the campaign in the East. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" and the corresponding Army headquarters at nearby "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mauerwald")]), _vm._v(" would be largest and most complex of all the command installations. During the war, 12.9 million working days, each lasting between eight and sixteen hours, were spent on building the various "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerhauptquartiere")]), _vm._v(" across Europe. The workforce reached 1.5 million as the war progressed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hitler officially ordered the construction of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mauerwald")]), _vm._v(" on 15 November 1940, with the instruction that the work had to be complete by the following April. Work soon began on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(". The forest was cleared of inhabitants and buildings and a forbidden zone with a radius of 10km extended around the site surrounded by barbed wire and fences, and the road from Rastenburg was given a new asphalt surface. Outside and inside the main perimeter fence were infantry trenches, dugouts, munitions depots and wooden barracks for the guards and a fire brigade crew. Inside the fence there was also a minefield approximately 150m wide as well as camouflaged watch towers that stood up to 35m high. At each entrance to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" was a barrier, on both sides of which were displayed signs that read, ‘Stop Military Object. No Admittance to Civilians’. Once permitted through the barriers, which were guarded night and day, other signs warned visitors: ‘It is forbidden to leave this road. Danger to Life. Commanding Officer’. Similar signs were placed all around the perimeter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The use of the Askania Chemical Works as a ‘front’ enabled the legitimate purchase of materials from unsuspecting contractors. These included the firm Hoyer from Hamburg, which produced monolithic reinforced concrete structures; the Draiger (or Draeger) company, which dealt with ventilation and filtering systems; Klaus Ackermann, which made reinforced concrete blocks; and the company Warenvertrieb GmbH, which dealt with barracks, warehouses and service structures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thousands of construction workers of the Organisation Todt and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hochtief Aktiengesellschaft")]), _vm._v(" were transported into the area under the auspices of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Konstrukionsburo")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn2",
      "id": "ch1fn2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The companies Wayss & Freytag and Dyckerhoff & Widmann, which specialised in bunker construction, acted as general contractors for the construction work. All the workers all wore greenish-brown uniforms that had been taken from the Czech army in 1939 following the German invasion of that country.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0004-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The former Hindenburg Barracks at Rastenburg.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("The area around Rastenburg was soon populated by work detachments, with some of the workers being accommodated in the town itself and in the local Hindenburg Army barracks. The Organisation Todt also had a building materials warehouse at Rastenburg train station as well as a food depot at the Rastenburg Sugar Factory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just how many people were employed on the building work on the Wolf’s Lair is not known with any degree of certainty and figures from 2,000 to more than 5,000 have been suggested. These workers were repeatedly checked for security concerns by officials of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Reichssicherheitsdienst")]), _vm._v(" (RSD), the Reich Security Service, and the construction sites and material stores were guarded by soldiers and the Organisation Todt’s own Protection Command. All tools and other equipment used by the workers were signed out and checked back in, normally by a member of the RSD. Access to the building site was by specially issued passes. To enable the work to continue around the clock, floodlights were brought into the site. To help keep the true nature of the work in which they were involved secret, workers’ brigades were sent home or transferred to other construction sites after several months.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ironically, it was at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" that Todt died, being killed in February 1942 when his Heinkel He 111 crashed on take-off from Rastenburg airfield. Sabotage was suspected, though never proved, but from that date onwards before any flight Hitler’s fleet of aircraft was searched for suspicious packages.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Dr Todt speaking with a worker on a construction site on the Eastern Front.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("The Rastenburg airport is some 4km from Rastenburg and from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(". The airport was originally built for sports aviation in 1935 and was not suitable for Hitler’s personal aircraft (the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führermachine")]), _vm._v(") a large, four-engine Focke-Wulf Fw 200C-4/U1 Condor. During the construction of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(", the airport’s concrete runways were extended and strengthened but until this work was completed, Gerdauen airfield some 20 miles away was used, with Junkers Ju 52s providing a shuttle service with Rastenburg. The X format of the runways is still visible to this day. More than 200 buildings were built in the area around the airfield, which included, barracks, a power station, a radio station, a radar installation, a materials store with replacement engines, workshops and crew lounges. However, there were no runway lights at the airfield, which meant that landings could only take place during daylight. The senior officers of Hitler’s air squadron, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fliegerstaffel des Führers")]), _vm._v(", such as SS-Gruppenführer Hans Baur, Hitler’s personal pilot, as well as some of the crews, were quartered in private houses in the town.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Hans Baur, the Luftwaffe had up to twenty aircraft on the ground at Rastenburg, always ready for the use of Hitler and senior officers. Included among these were two other Condors to transport Hitler’s staff when the Führer was on the move."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn3",
      "id": "ch1fn3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Also stationed at Rastenburg was the courier squadron ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kurierstaffel")]), _vm._v(") for the daily courier service from Berlin. This unit, commanded by Hauptmann Talk, was composed of between six and twelve fighter aircraft, which were also used for the rapid transport of messages and dispatches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time that work was undertaken on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Nord")]), _vm._v(", construction began at two other sites in Poland – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Mitte")]), _vm._v(" (Camp Centre) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Süd")]), _vm._v(" (Camp South). "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Mitte")]), _vm._v(", near the village of Konewka, north-east of the town of Tomaszów Mazowiecki, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Süd")]), _vm._v(" at Stępina, near Krosno, were only temporary sites for the protected parking of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führersonderzug")]), _vm._v(" and Wehrmacht staff trains. Both of these sites had two similar complexes, a few kilometres from each other, built by Organisation Todt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The complexes at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Süd")]), _vm._v(" consisted of two long concrete bunkers built near the rail line between Rzeszów and Jasło for parking, and hiding, Hitler’s train and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Atlas")]), _vm._v(", the train of the Armed Forces Operations Staff ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wehrmachtführungsstabes")]), _vm._v("). The first of these massive facilities was a bunker located in the village of Stępina and the other was a tunnel cut through a hill by the town of Strzyżów. These two tunnels alone involved the employment of some 7,000 workers for almost a year, totalling 1.2 million days’ labour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The complex at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Mitte")]), _vm._v(", consisted of two bunkers at Konewka and Jelen. At Konewka were two pump houses, a news centre, a conference bunker, and several residential and service buildings.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0007-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Hitler’s Condor at Immola Airfield, where he flew from Rastenburg to visit Marshal of Finland Baron Carl Gustaf Emil Mannerheim on his 75th birthday on 4 June 1942.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tunnel/bunkers at all sites had a platform so that passengers could embark and disembark with ease. Each tunnel was in the region of 480m long, 8.3m wide and 12m high, with concrete walls 2m thick. The tunnel portals were protected by two-wing armoured doors with firing embrasures for the guards. With each site were a few huts and a complex of bunkers for power generation and water supply. Each site was surrounded by fences and wooden watchtowers and anti-aircraft gun positions, with other buildings used for personnel engaged in operations, administration, and maintenance."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn4",
      "id": "ch1fn4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" The only times these sites were used by Hitler were on 27–28 August 1941, when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Amerika")]), _vm._v(" was parked in the Strzyżów tunnel of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Süd")]), _vm._v(", while Mussolini’s train was parked in the nearby bunker at Stępina, and a second time in October of that year. Other senior figures of the Third Reich, including Generalfeldmarschall Rommel and SS commander Heinrich Himmler, also used the tunnels."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn5",
      "id": "ch1fn5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the bunkers and the tunnel still survive and can be visited. The Konewka Bunker now houses a small collection of artefacts and of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Süd")]), _vm._v(", the one at Stępina is open to the public."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn6",
      "id": "ch1fn6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the main reasons why the Görlitz forest had been chosen by Fritz Todt was the cover the woodland would provide, for security was of the greatest concern and dictated the entire nature of the complex. The forest, however, was only 2,000m wide and was not uniformly dense, and there were numerous open spaces, plus some trees had to be felled to create the space for the installations. This meant that camouflage netting had to be hung from trees to the edges of the buildings to conceal the installations. Where there were insufficient trees to hang the netting, artificial ones were planted. The buildings themselves, of which there were eventually more than eighty in total, were also camouflaged. The complex covered approximately 2.5 square miles, only 4 per cent of which held buildings and other installations.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("Hitler seen here greeting Mussolini at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Süd")]), _vm._v(" on 27 August 1941.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0008-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("‘The artificial tunnel at Stępina.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0009-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("A side tunnel branching off the main one at Stępina used as staff quarters.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Inside the Stępina tunnel. The tracks at both "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Süd")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Mitte")]), _vm._v(" were covered over with wood after the war.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0010-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Another view of the tunnel at Stępina.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("The entrance to the Konewka Bunker.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0011-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Konewka bunker has been converted into a museum. The complex includes shelters for a generator, a boiler room, a water-pumping room, a well, a water cooler and a fuel tank.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0012-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Inside "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anlage Mitte")]), _vm._v(". The facilities were used in 1944 under the aliases ‘Goldamsel’ and ‘Huhn’ as ammunition storage and workshops for aircraft engines.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0013-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("The camouflage that covered the tunnels helped conceal them from the air.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most buildings constructed there had flat roofs with side walls 10–30cm high filled with soil. A specialist gardening company from Stuttgart, called Seidenspinner, was then employed to plant shrubs and lay grass, and even place more artificial trees, on the top of buildings, to give the impression from the air of an unbroken leafy canopy."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn7",
      "id": "ch1fn7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" The roads and paths throughout the site, which were 2–3m wide, were also hidden with green camouflage nets, which were hung on eyelets that had been built into the sides of the buildings, and at night lighting along the roads was with navy blue electric lights on 2.5m-high concrete posts shaded from above. Rubbish baskets were placed at intervals along the paths. To aid orientation, most of the buildings were numbered, with those numbers being displayed on signposts. Those numbers are not the same as those seen on the buildings today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The roads through the complex were based on the existing network of paths in the forest and, in principle, the buildings were not placed in parallel nor at right angles to each other to try and maintain the natural appearance of the forest from the air.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("Although this photo was taken in July 1944 after the failed assassination attempt, the wall at the rear of the group shows what the camouflage was like at the time.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The camouflage, which was a mixture of seagrass, green dye and concrete, was so resilient that it can still be seen on many of the buildings.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("A further example of the camouflage that covered the buildings can be seen here, as can the shutters that protected the windows. The man shaking hands with Hitler is Grand Admiral Karl Dönitz, who became Commander-in-Chief of the Navy (Oberbefehlshaber der Kriegsmarine) on 30 January 1943.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("The tops of the lights in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" were covered to conceal them from the air, one of which can be seen in the background of this photograph, which is of Marshal of Finland Carl Mannerheim in discussion with Hitler and Keitel, in the company of other German officers, during a visit to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" in late June or early July 1942.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This evidently proved adequate, as the Wolf’s Lair was never subjected to a serious attack from the air, and, despite Hitler’s conviction that the Soviets knew about the site, the Red Army was seemingly unaware of the complex until they overran the site in early 1945."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn8",
      "id": "ch1fn8a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Indeed, aerial photographs were taken to verify the effectiveness of the camouflage efforts, and chief of the OKW Generalfeldmarschall Wilhelm Keitel declared in his memoirs that: ‘I have often flown over the site at various altitudes, but despite my precise knowledge of its location was never able to pin-point it from the air, except perhaps by the virtue of the lane leading through the forest and a single-track railway spur which had been closed to public traffic.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn9",
      "id": "ch1fn9a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This did not stop Hitler becoming increasingly convinced that his enemies knew exactly where his headquarters were located: ‘Hitler spoke more and more often of the possibility of a massive air raid on Führer headquarters,’ wrote Traudl June in her memoirs. ‘They know exactly where we are, and some time they’re going to destroy everything here with carefully aimed bombs. I expect them to attack any day.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn10",
      "id": "ch1fn10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("The Western Allies, through their intelligence and communications interception services, certainly did know the geographical location of the various "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerhauptquartiere")]), _vm._v(" and, should the USAAF or the RAF so have chosen, could have bombed the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(". But the distance from the air force bases in the UK was so great that only the heaviest bombers could have reached East Prussia, and they would have been without fighter escort. Raids on other targets in the east of Germany had resulted in very heavy losses among aircrew and any attempt to bomb the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" would have encountered stiff resistance. The question of dropping a ‘blockbuster’ bomb on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" was certainly debated amongst the Allies but, as there was no guarantee that any such attack would have coincided with Hitler being in residence, the value of such an operation was highly questionable in light of the known risks, and the decision to bomb the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" was never taken."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn11",
      "id": "ch1fn11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To further disguise the site’s true purpose, all the people working in the construction of Wolf’s Lair had civilian passports, and up until 21 June 1941, the day before the start of the invasion of the Soviet Union, civilian flights between Berlin and Moscow were permitted to fly over the site, including the scheduled operations of the Soviet airline Aeroflot. This added to the impression that the buildings in the forest had no real military significance, confirming them merely to being part of a chemical works."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn12",
      "id": "ch1fn12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The road Keitel referred to ran from Rastenburg to Angerburg (today’s Kętrzyn and Węgorzewo respectively), while the single-track railway was just to the north of the road and it too ran from Rastenburg to the small town of Görlitz. It was along these two avenues of communication that the material was transported that saw thousands of square metres of concrete poured, miles of cables installed, and tons of bricks laid across the vast site.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially, the buildings at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" were of wood or concrete-and-brick structures with high windows protected by steel shutters. The ten main bunkers had concrete walls and roofs a metre thick that could withstand the impact of 500kg bombs. Heavy steel doors were made gas-tight with rubber seals, and there was overpressure in the bunkers to prevent the ingress of poisonous gas. There were also gas locks, and machine guns and pistol loops for defence. The floor in the rear of each of these bunkers was 2m below ground level and was used for sleeping, and at ground level was a small work room large enough for two desks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the site was developed, the wooden hutments were covered with brick walls and concrete roofs. Then, in 1944, many of the existing buildings were massively reinforced with concrete and steel shells at least 4m thick, inside which was a 2m-thick shock-absorbing sand or basalt insulation. A few additional bunkers were also built with the same level of protection. The ruins of these windowless bunkers are what visitors today can see today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" had two central heating systems, and a pumping station on Lake Moysee provided the complex’s water supply. The main bunkers, such as those of Hitler, Bormann, Keitel and so on, had their own emergency heating systems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The site was constructed with three security zones. The outermost of these was Security Zone III ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" III). This outer perimeter was surrounded by land and fencing and defended by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führer-Begleit-Bataillon")]), _vm._v(" (FBB) with a strength in 1941 of 1,277, who manned slit trenches, guard houses, watch-towers and checkpoints. Beyond the perimeter of the complex was an extensive number of concrete gun emplacements strategically placed at road junctions and covering access roads. Armoured vehicles as well as troops on foot also made regular daily inspection trips along these roads."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn13",
      "id": "ch1fn13a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" The military formation responsible for guarding this area beyond "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" III was a battle-group (or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kampfgruppe")]), _vm._v(") under the command of Generalmajor Walter Denkert. In April 1943, a second unit was created to provide added security. This was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führergrenadierbataillon")]), _vm._v(" (FGB).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lakes and swampy ground that surround the forest might well have been excellent defensive features but, as we shall see, this also caused problems for the men and women living at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" in the form of the ferocious mosquitos. On 14 June 1941, before Hitler and the permanent staff moved into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(", an expert on dealing with mosquitos was flown in. What he did or recommended is not known, but he clearly failed to eradicate the problem.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Work under way on the reinforcing of the bunkers.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("Security Zone II ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" II) was the area inside the outer security zone, with its buildings situated to the south of the railway line. There could be found the buildings of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wehrmachtführugsstab")]), _vm._v(", the Armed Forces Joint Staff, and the headquarters of the Commandant of the Wolf’s Lair, Oberstleutnant Gustav Streve, and his staff. This was a self-contained area with its own dining and accommodation blocks. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" II was surrounded by fencing but was not subject to any additional security controls. Commanded by General der Artillerie Walter Warlimont, deputy chief of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Oberkommando der Wehrmacht")]), _vm._v(", the main function of the personnel in this area was to deliver pre-processed daily news and reports from all the theatres of war. These were then analysed by Hitler at his daily situation briefings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Security Zone I ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" I) was the most secure area of the Wolf’s Lair. It was ringed by steel fencing and guarded by the RSD, which had overall responsibility for Hitler’s security, and the SS-"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Begleitkommando des Führers")]), _vm._v(", Hitler’s personal bodyguard. Within it were eleven buildings, including the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerbunker")]), _vm._v(" and bunkers for Hitler’s closest associates, such as his secretary Martin Bormann, Chief of Operation Staff of the OKW Alfred Jodl, Reichsmarschall Göring and Keitel. Hitler’s own accommodation was on the northern side of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerbunker")]), _vm._v(" to shield the Führer from the direct sunlight he so detested. Both Hitler’s and Keitel’s bunkers had additional rooms where military conferences could be held.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were other buildings scattered across the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" that were not within the fenced areas of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" I or II. Generally speaking, most of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" buildings had more than one entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On 20 September 1943, security at the Wolf’s Lair was tightened with the creation of an inner zone within "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" I, called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" A or IA, by General der Infanterie Rudolf Schmundt, Hitler’s adjutant and chief of the German Army Personnel Office. The only buildings in this new restricted zone apart from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerbunker")]), _vm._v(" were those of Generalfeldmarschall Keitel, the Führer’s personal adjutants, Reichsleiter Martin Bormann, the security command centre, Dining Room I and the Tea House.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before Hitler moved into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(", 1. Bataillon Flak Regiment 604 arrived on 6 June 1941 to provide anti-aircraft protection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" continued to be developed over the years of its occupation, with most of the brick buildings being covered in concrete in what is generally considered to be the second building phase in 1943. The third and final building stage the following year saw the main buildings turned into massive concrete structures, and when Hitler and his entourage returned there in the summer of 1944 because of the deteriorating situation on the Eastern Front, they were astonished at what they saw. ‘The place was barely recognisable,’ wrote Traudl Junge, one of Hitler’s secretaries. ‘Instead of the "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("low-built little bunkers, heavy, colossal structures of concrete and iron rose above the trees, there was nothing to be seen from above. Grass had been planted on the flat rooftops, trees grew from the concrete, some of them real and some artificial, and from the plane you would have thought the forest stretched on unbroken.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Notes#ch1fn14",
      "id": "ch1fn14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In total, the complex numbered more than eighty buildings, of which about forty were residential and commercial buildings, forty were light reinforced concrete storage bunkers and there were seven massive fortified structures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Work on these improvements at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" was still ongoing when Hitler visited his headquarters for the last time in the summer of 1944. Until his restructured bunker was ready for occupation, a new inner zone, the Führer Security Zone, was established in the north-west of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sperrkreis")]), _vm._v(" I, where Hitler resided temporarily in the bunker normally reserved for important guests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As might be imagined, security was increased following the assassination attempt on 20 July 1944, and a detachment of the Liebstandarte-SS Adolf Hitler was assigned to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" to support the FBB. The SS arrived with an array of weapons, including anti-tank guns, artillery, armoured vehicles, panzers, assault guns and tank destroyers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hitler himself gave his new "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerhauptquartiere")]), _vm._v(" its name as he travelled there for the first time. Hitler often liked to refer to himself as ‘Herr Wolf’, as Adolf in Old High German meant ‘noble wolf’, and three other headquarters included this reference to Hitler in their titles – the Werwolf at Vinnytsia in Ukraine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschlucht")]), _vm._v(" I near Couvin, Belgium, and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschlucht")]), _vm._v(" II near Soissons in France. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Schanze")]), _vm._v(" means an entrenchment or fieldwork. So, more accurately, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(" (which is also spelt "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfschanze")]), _vm._v(" on period documents and at the site itself) should be referred to as the Wolf’s Field Fortification. These spellings contradict the spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschlucht")]), _vm._v(", which is also used. It was in this massive field fortification that Hitler spent more than 800 days directing his war against the Soviet Union.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The prolonged effort against the Soviet Union was on such a massive scale that all the other key branches of the German military and intelligence services erected headquarters of their own in East Prussia within a 50km range of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wolfsschanze")]), _vm._v(". These included, as already mentioned, the headquarters of the Army at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mauerwald")]), _vm._v(", as well as that of the Luftwaffe near Goldap, Himmler’s SS near today’s Pozezdrze, the German military intelligence service, Fremde Heere Ost, at Fortress Boyen, and that of the Chief of the Reich Chancellery, Hans Lammers, near the village of Radzieje, all of which will be examined in greater detail.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30233178","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Chapter01.vue
// module id = 75
// module chunks = 0